import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "my-4" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { ref: "pre" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 1,
  class: "text-caption"
}
const _hoisted_7 = {
  key: 1,
  class: "text-caption"
}
const _hoisted_8 = {
  key: 1,
  class: "text-caption"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["href"]
const _hoisted_11 = {
  key: 1,
  class: "text-caption"
}
const _hoisted_12 = {
  key: 1,
  class: "chat-bubble"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_Code = _resolveComponent("Code")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, { class: "msg" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_btn, {
          class: "expand-btn",
          icon: _ctx.show ? 'mdi-chevron-up' : 'mdi-chevron-down',
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.show = !_ctx.show)),
          variant: "text",
          size: "x-large"
        }, null, 8, ["icon"]),
        _createVNode(_component_v_expand_transition, null, {
          default: _withCtx(() => [
            (!_ctx.show)
              ? (_openBlock(), _createBlock(_component_v_card_title, {
                  key: 0,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.show = !_ctx.show)),
                  class: "clickable d-block mr-8 mb-n4"
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode(" Full Analysis ")
                  ])),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_expand_transition, null, {
              default: _withCtx(() => [
                (_ctx.show)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      (_ctx.msgFormatted !== '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createElementVNode("pre", _hoisted_4, [
                              _createElementVNode("code", {
                                class: "chat-text language-markdown",
                                innerHTML: _ctx.msgFormatted
                              }, null, 8, _hoisted_5)
                            ], 512),
                            _createVNode(_component_v_expansion_panels, { class: "mt-4" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_expansion_panel, {
                                  title: "Income Statements",
                                  onClick: _ctx.incomeStatementClicked
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_expansion_panel_text, null, {
                                      default: _withCtx(() => [
                                        (_ctx.incomeStatementSummary !== '')
                                          ? (_openBlock(), _createBlock(_component_Code, {
                                              key: 0,
                                              msg: _ctx.incomeStatementSummary
                                            }, null, 8, ["msg"]))
                                          : (_openBlock(), _createElementBlock("p", _hoisted_6, "Fetching income statement summary..."))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]),
                                _createVNode(_component_v_expansion_panel, {
                                  title: "Cashflow Statements",
                                  onClick: _ctx.cashflowStatementClicked
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_expansion_panel_text, null, {
                                      default: _withCtx(() => [
                                        (_ctx.cashflowStatementSummary !== '')
                                          ? (_openBlock(), _createBlock(_component_Code, {
                                              key: 0,
                                              msg: _ctx.cashflowStatementSummary
                                            }, null, 8, ["msg"]))
                                          : (_openBlock(), _createElementBlock("p", _hoisted_7, "Fetching cashflow statement summary..."))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]),
                                _createVNode(_component_v_expansion_panel, {
                                  title: "Balance Sheets",
                                  onClick: _ctx.balanceSheetClicked
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_expansion_panel_text, null, {
                                      default: _withCtx(() => [
                                        (_ctx.balanceSheetSummary !== '')
                                          ? (_openBlock(), _createBlock(_component_Code, {
                                              key: 0,
                                              msg: _ctx.balanceSheetSummary
                                            }, null, 8, ["msg"]))
                                          : (_openBlock(), _createElementBlock("p", _hoisted_8, "Fetching balance sheet summary..."))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]),
                                _createVNode(_component_v_expansion_panel, {
                                  title: "News",
                                  onClick: _ctx.newsClicked
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_expansion_panel_text, null, {
                                      default: _withCtx(() => [
                                        (_ctx.allNews != null)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                              _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "text-h4 mb-4" }, "News Summary/Highlights", -1)),
                                              _createVNode(_component_Code, {
                                                msg: _ctx.allNews.newsSummary.summary
                                              }, null, 8, ["msg"]),
                                              _createElementVNode("ul", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allNews.newsSummary.links, (link) => {
                                                  return (_openBlock(), _createElementBlock("li", { key: link }, [
                                                    _createElementVNode("a", {
                                                      href: link,
                                                      target: "_blank"
                                                    }, _toDisplayString(link), 9, _hoisted_10)
                                                  ]))
                                                }), 128))
                                              ])
                                            ]))
                                          : (_openBlock(), _createElementBlock("p", _hoisted_11, "Fetching news summary..."))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            })
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_12, _cache[4] || (_cache[4] = [
                            _createElementVNode("div", { class: "typing" }, [
                              _createElementVNode("div", { class: "dot" }),
                              _createElementVNode("div", { class: "dot" }),
                              _createElementVNode("div", { class: "dot" })
                            ], -1)
                          ])))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}